var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSbp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4873 5.57048L6.03037 10.116V12.8887L3.49028 17.4253L3.4873 5.57048Z",
    fill: "#5B57A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.251 8.46276L15.6339 7.00223L20.5107 6.99768L13.251 11.4451V8.46276Z",
    fill: "#D90751"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2377 5.54416L13.2512 11.5623L10.7021 9.99609V1L13.2377 5.54416Z",
    fill: "#FAB718"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5109 6.99734L15.6339 7.00189L13.2377 5.54416L10.7021 1L20.5109 6.99734Z",
    fill: "#ED6F26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2512 17.4516V14.5318L10.7021 12.9953L10.7035 22.0003L13.2512 17.4516Z",
    fill: "#63B22F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6286 16.0033L6.03019 10.116L3.4873 5.57048L20.5011 15.9974L15.6286 16.0033Z",
    fill: "#1487C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7041 21.9997L13.2514 17.451L15.6284 16.0038L20.5008 15.9979L10.7041 21.9997Z",
    fill: "#017F36"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49023 17.4249L10.7234 12.994L8.29164 11.502L6.03032 12.8883L3.49023 17.4249Z",
    fill: "#984995"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbp);
export default __webpack_public_path__ + "static/media/sbp.92f294bc289040c6e753ec733ffddcf6.svg";
export { ForwardRef as ReactComponent };